import { ReactNode } from "react";

/** Page heading with a row of details underneath (concept `.ptitle`). */
export const PlanPageTitle = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <div className="flex min-w-0 flex-col gap-2">
    <h1 className="m-0 text-[2rem] font-semibold leading-[1.2] tracking-[-0.01em] text-black/[.87] [text-wrap:balance]">
      {title}
    </h1>
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1 text-black/60">
      {children}
    </div>
  </div>
);
